import { captureErrorAsync } from '../../utils/capture-error-async';
import { loadScript } from '../../utils/load-script';
import { globalVarReady } from '../../utils/ready';
import { logger } from './logger';
import './types';

type Variables = Record<string, never>;

const src = 'https://static.floorforce.com/init-2.min.js';

function isAlreadyInstalled() {
  return document.querySelector(`script[src="${src}"]`) != null;
}

async function configBroadstreet() {
  let broadstreet: (typeof window)['broadstreet'];
  const networkId = 4832;

  try {
    broadstreet = await globalVarReady('broadstreet', { reportErrors: false });
  } catch (e) {
    return;
  }

  broadstreet.setOptions({ domain: 'sponsors.floorforce.com' });

  // You would generally only use this if you did not call broadstreet.watch after including the init script
  broadstreet.loadNetworkJS(networkId);
}

async function installBroadstreetScript() {
  if (isAlreadyInstalled()) {
    logger.debug('Broadstreet script is already loaded.');
    return;
  }

  try {
    await loadScript(src);
    logger.debug(`Successfully loaded Broadstreet script from ${src}`);
  } catch (e) {
    logger.error(`Could not load Broadstreet script from ${src}`);
    captureErrorAsync(e as Error);
  }

  await configBroadstreet();
}

export function install(_: Variables): void {
  installBroadstreetScript();
}
